<template>
    <b-modal :visible="isVisible"
             lazy
             centered
             ok-only
             ref="modalObject"
             title=""
             size="xl"
             no-close-on-backdrop
             ok-variant="outline-secondary">
        <div class="d-block text-center">
            <div v-for="(entityValue, index) in entityValues" v-bind:key="index"  class="form-group col-md-2">
                <label class="control-label">{{$t(entityValue.label)}}:</label>
                <span>{{entityValue.value}}</span>
            </div>
        </div>
    </b-modal>
</template>

<script>

    import model from '@/model/index'

    export default {
        name: "mmf-entity-viewer-modal",
        props: {
            'isVisible': Boolean,
            'object': Object,
            'entity': String
        },
        data: function() {
            return {
                entityValues: []
            }
        },
        mounted(){
            // var me = this;
            let gridFields = model[this.entity].gridFields();
            for (let i in gridFields) {
                let field = gridFields[i]
                var value = this.getValue(field)
                this.entityValues.push({
                    label: field.label,
                    value: value
                });
            }
        },
        methods: {
            getValue(field) {
                let fieldValue = this.object[field.key]
                switch (field.form.type) {
                    case 'boolean':
                        return fieldValue ? 'Yes' : 'No'
                    case 'select':{
                        let selectedOption = field.form.options.filter(x => x.value === fieldValue)
                        if (selectedOption.length > 0) {
                            return selectedOption[0].text;
                        }
                        return null
                    }
                    default:
                        return fieldValue
                }
                //   return null;
            },
            getTitle() {
                return this.$t('modal.custom.title');
            }
        }
    }
</script>